// extracted by mini-css-extract-plugin
export default {"block":"Ad","smallprint":"Bd","asterisk":"Cd","label":"Dd"};